import { useSuspenseQuery } from "@tanstack/react-query";

import { getUserScore } from "~/data/dashboard/dashboard.service";

export function Score() {
  const { data } = useSuspenseQuery({
    queryKey: ["score"],
    queryFn: getUserScore,
  });
  return (
    <div className="absolute grid grid-cols-[auto_1fr] gap-5">
      <div className="relative flex justify-center items-center">
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          className="w-16 h-16"
        >
          <circle
            cx="60"
            cy="60"
            r="50"
            stroke="#d1d5db"
            strokeWidth="10"
            fill="none"
          />
          <circle
            cx="60"
            cy="60"
            r="50"
            stroke="#00C2CB"
            strokeWidth="10"
            fill="none"
            strokeDasharray="314"
            strokeDashoffset={314 - (314 * data.cutoff_score) / 10}
            transform="rotate(-90 60 60)"
          />
        </svg>
        <span className="absolute mb-1 text-3xl font-semibold text-secondary-1">
          {data.cutoff_score.toFixed(1)}
        </span>
      </div>

      <p className="truncate text-sm font-alternative text-[#5B5B5B]">
        Avaliação de desempenho
        <br />
        As notas abaixo dizem respeito ao seu desempenho no estudo realizado.
        <br />
        Diferentes categorias constituem sua nota geral.
        <br />
        Analise em quais categorias você pode melhorar para aumentar seu
        resultado geral.
      </p>
    </div>
  );
}
